export class AccFormsUrlResultDto {
  guidelineUrl: string;
  applicationUrl: string;
}
